export const sbxSpinner = {
  route: () => import('./SbxSpinner.vue'),
  propTypes: {},
};
